import { PaymentType } from '~/types/api/payments'

type I18nKeys = {
  forAppSubscriptionUsers: 'for_app_subscription_users' | 'for_app_subscription_users_android'
  pleaseUnsubscribeFromBelowButton:
    | 'please_unsubscribe_from_below_button'
    | 'please_unsubscribe_from_below_button_android'
  cancelSubscription: 'cancel_app_store_subscription' | 'cancel_android_subscription'
}

type Message = {
  [key in Extract<PaymentType, 'ios' | 'android'>]: I18nKeys
}

const MESSAGES: Message = {
  ios: {
    forAppSubscriptionUsers: 'for_app_subscription_users',
    pleaseUnsubscribeFromBelowButton: 'please_unsubscribe_from_below_button',
    cancelSubscription: 'cancel_app_store_subscription',
  },
  android: {
    forAppSubscriptionUsers: 'for_app_subscription_users_android',
    pleaseUnsubscribeFromBelowButton: 'please_unsubscribe_from_below_button_android',
    cancelSubscription: 'cancel_android_subscription',
  },
}

export function getI18nKeys(paymentType: PaymentType | undefined): I18nKeys | undefined {
  switch (paymentType) {
    case 'ios':
    case 'android':
      return MESSAGES[paymentType]
    default:
      return undefined
  }
}
